import { RoundType } from "app/game-data/useFetchGameData";

export const ROUND_TITLE_BY_ROUND_TYPE = {
  [RoundType.SPELLING_BEE]: "Spelling Bee",
  [RoundType.BUZZ_IN]: "Buzz-In",
  [RoundType.SPEED]: "Speed",
  [RoundType.TED_WORD]: "TED Word",
  [RoundType.ONE_CHANCE]: "Final Round",
};

export const GAME_SETTINGS = {
  // This is the minimum number of points deducted from a word's score when
  // the user earns partial credit.
  partialCreditDeduction: 10,

  // If the user gets this percentage of characters wrong in their spelling,
  // they will recieve 0 correctness regardless of what the fuzzy match
  // algorithm says.
  wrongCharsCutoff: 0.4,

  // Words with a match percentage below this cutoff will be marked as wrong
  matchCorrectThreshold: 0.3,
};

export const SPELLING_BEE_SETTINGS = {
  maxWordScore: 20,
}

export const BUZZ_IN_SETTINGS = {
  timerInterval: 0.016,
  baseWordPoints: 30,
  maxBonus: 20,
  gracePeriod: 3.0,

  // Whether the player is allowed to start listening to the word again after
  // buzzing in once
  allowListenAfterBuzzIn: true,
};

export const SPEED_SETTINGS = {
  timerInterval: 100,
  maxTimeScore: 50,
  wordCorrectBonus: 5,
  timePerWord: 7500,
  gracePeriodPerWord: 1500,
  incorrectPenalty: 5,
  partiallyCorrectPenalty: 0,
  skipPenalty: 5,
  // Score bonus earned at end of round depending on streak level
  streakBonuses: {
    2: 10,
    3: 20,
    4: 30,
    5: 40,
    6: 50,
    7: 65
  } as Record<number, number>,
};

export const TED_WORD_SETTINGS = {
  maxAttempts: 3,
  maxScore: 100,
  // The amount subtracted from the max score when the player gets a wrong
  // answer
  scoreSubtracted: 25,
};

export const ONE_CHANCE_SETTINGS = {
  numLetterBoxes: 20,

  initMult: 2.5,
  minMult: 1.1,
  definitionMultCost: 0.1,
  letterRevealMultCost: 0.1,
  letterRevealMultCostIncrease: 0.1,
  maxLetterReveals: 3,
  originMultCost: 0.1,
  lengthMultCost: 0.3,

  // Together affect how long a letter box must be held to reveal its contents
  letterBoxTimerDelta: 25,
  letterBoxRevealTime: 400,
};
